import React, { useEffect, useRef, useState } from "react"
import './PermitBasicPage.css';
import { useForm } from "antd/es/form/Form";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Select, TimePicker, Tooltip, DatePicker, Pagination } from "antd";
import { SearchOutlined, PlusSquareFilled } from '@ant-design/icons';
import Table_Comp from "../../Components/Table_Comp/Table_Comp";
import Loader from "../../Components/Loader/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { usePermitStore } from "../../Store/store";
const { TextArea } = Input;

const PermitBasicPage = () => {
    const Navigate = useNavigate();
    const [BasicInsert] = useForm();
    const [ShowBasiDetail, setShowBasiDetail] = useState(false);
    const [LoaderHiden, setLoaderHiden] = useState(false)
    const [TableShowData, setTableShowData] = useState({});
    const [SearchData, setSearchData] = useState("")
    const [LoginInfo, setLoginInfo] = useState()
    const [PlantMasterData, setPlantMasterData] = useState([])
    const [AreaMasterData, setAreaMasterData] = useState([])
    const [DepartmentBasedDevision, setDepartmentBasedDevision] = useState([])
    const formRef = useRef(null)
    const [current, setCurrent] = useState(1);
    const [area, setArea] = useState('');
    let setSize = false;

    const { setExportBasicDetail } = usePermitStore((state) => ({
        setExportBasicDetail: state.setExportBasicDetail
    }))

    useEffect(() => {
        setLoginInfo(JSON.parse(sessionStorage.getItem("UserInfo")))
        GetPlantMaster(JSON.parse(sessionStorage.getItem("UserInfo")))
        GetDepartmentBasedDevision(JSON.parse(sessionStorage.getItem("UserInfo")))
        getPermitTableDetail(JSON.parse(sessionStorage.getItem("UserInfo")))
    }, [])

    useEffect(() => {
        if (formRef.current)
            BasicInsert.setFieldsValue({
                DivsionName: LoginInfo?.divisionName,
                IssueDate: dayjs(new Date()),
                IssueStartTime: dayjs('09:00:00', 'HH:mm:ss'),
                IssueEndTime: dayjs('17:00:00', 'HH:mm:ss')
            })
    }, [ShowBasiDetail])

    const getPermitTableDetail = (data) => {
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetBaicDetailsByEmpID?Empid=" + data.employeeId + "&page=1" + "&pageSize=10"
        axios.get(URL).then((Res) => {
            setTableShowData(Res.data)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    }

    const onSreach = (SearchData) => {
        if (SearchData.length > 3) {
            let URL = process.env.REACT_APP_PERMIT + "/Master/GetBaicDetailsByEmpID?Empid=" + LoginInfo?.employeeId + "&page=1" + "&pageSize=10" + "&Search=" + SearchData
            axios.get(URL).then((Res) => {
                setTableShowData(Res.data)
            })
        }
        else {
            let URL = process.env.REACT_APP_PERMIT + "/Master/GetBaicDetailsByEmpID?Empid=" + LoginInfo?.employeeId + "&page=1" + "&pageSize=10"
            axios.get(URL).then((Res) => {
                setTableShowData(Res.data)
            }).catch((Error) => {
                console.log(Error, "Error GetNatureofwork")
            })
        }
    };

    const RowClick = (data) => {
        if (data.dataItem.permitNumber !== "" && data.dataItem.permitNumber !== null) {
            Navigate("/PermitViewPage", { state: data.dataItem })
        }
        else {
            let basicDetailID = data.dataItem.basicDetailID
            let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitByBasicID?BasicDetailID=" + basicDetailID
            axios.get(URL).then((Response) => {
                setExportBasicDetail(Response.data.basicDetails)
                Navigate("/PermitMaster", { state: data.dataItem });
            }).catch((Error) => {
                setLoaderHiden(false)
                console.log(Error, "Error Insert_PRRequest")
            })
        }
    };

    const RowClickMob = (data) => {
        if (data.permitNumber !== "" && data.permitNumber !== null) {
            Navigate("/PermitViewPage", { state: data })
        } else {
            let basicDetailID = data.basicDetailID
            let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitByBasicID?BasicDetailID=" + basicDetailID
            axios.get(URL).then((Response) => {
                setExportBasicDetail(Response.data.basicDetails)
                Navigate("/PermitMaster", { state: data });
            }).catch((Error) => {
                setLoaderHiden(false)
                console.log(Error, "Error Insert_PRRequest")
            })
        }
    };

    const GetPlantMaster = (data) => {
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetplantBasedonDevision?Devison=" + data.divisionID
        axios.get(URL).then((Res) => {
            setAreaMasterData([])
            setPlantMasterData(Res.data)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    }

    const PlantMasterChange = (event) => {
        let data = event
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetAreaBasedonPlant?Plant=" + data
        axios.get(URL).then((Res) => {
            setAreaMasterData(Res.data)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    }

    const AreaMasterChange = (event) => {
        setArea(event);
        if (event !== "Others") {
            BasicInsert.setFieldsValue({ MentionArea: '' });
        }
    };

    const GetDepartmentBasedDevision = (data) => {
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetDepartmentBasedonDevision?Devison=" + data.divisionID
        axios.get(URL).then((Res) => {
            setDepartmentBasedDevision(Res.data)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    }

    const createPermit = () => {
        setShowBasiDetail(true)
    }

    const clearToPermit = () => {
        BasicInsert.resetFields()
        setShowBasiDetail(false)
    }

    const BasicInsertForm = () => {
        setLoaderHiden(true)
        let Input = {}
        Input = BasicInsert.getFieldsValue()
        // console.log(Input, "InsertValues")
        let Input_Value = {
            jobDescription: Input.DescriptionOfWork,
            plant: Input.Plant,
            area: Input.Area,
            departmentID: Input.Department,
            mentionArea: Input.MentionArea !== "" ? Input.MentionArea : null,
            nameofPersons: Input.NameOfPersons.replace(/\n/g, ''),
            issueDate: new Date(Input.IssueDate.$d),
            issueStartTime: new Date(Input.IssueStartTime.$d),
            issueEndTime: new Date(Input.IssueEndTime.$d),
            name: Input.Name,
            nameofEmployee: Input.ContractorName,
            numberofPersons: parseInt(Input.NumberOfPersons),
            empID: LoginInfo.employeeId,
            division: LoginInfo.divisionID
        }
        // console.log(Input_Value, "Input_Value")
        let URL = process.env.REACT_APP_PERMIT + "/Master/CreateBasicDetails"
        axios.post(URL, Input_Value).then((Res) => {
            setLoaderHiden(false)
            if (Res.data > 0) {
                let BasicDetailID = Res.data;
                let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitByBasicID?BasicDetailID=" + BasicDetailID
                axios.get(URL).then((Response) => {
                    setExportBasicDetail(Response.data.basicDetails)
                    BasicInsert.resetFields()
                    toast.success("Basic Details Successfully Saved")
                    Navigate("/PermitMaster");

                }).catch((Error) => {
                    setLoaderHiden(false)
                    console.log(Error, "Error Insert_PRRequest")
                })
            } else {
                toast.error("Data Not Insert")
            }
        }).catch((Error) => {
            setLoaderHiden(false)
            console.log(Error, "Error Insert_PRRequest")
        })
    };

    const onChangeLogic = (current, size) => {
        setLoaderHiden(true)
        let EmpNo = LoginInfo.employeeId;
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetBaicDetailsByEmpID?Empid=" + EmpNo + "&page=" + current + "&pageSize=" + size
        axios.get(URL).then((Res) => {
            setTableShowData(Res.data)
            setLoaderHiden(false)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
        !setSize && setCurrent(current);
    };

    const handleKeypress = (e) => {
        const characterCode = e.key
        if (characterCode === 'Backspace') return

        const characterNumber = Number(characterCode)
        if (characterNumber >= 0 && characterNumber <= 9) {
            if (e.currentTarget.value && e.currentTarget.value.length) {
                return
            } else if (characterNumber === 0) {
                e.preventDefault()
            }
        } else {
            e.preventDefault()
        }
    }

    return (
        <div className="FormMainClass">
            {LoaderHiden && <Loader />}
            {ShowBasiDetail &&
                <>
                    <div className="HreaderClass">
                        <h4 className="Heading">Basic Details</h4>
                    </div>

                    <div>
                        <h5 className="SubHeading">To Be Filled Plant Representative / Initiator :</h5>
                    </div>
                    <Form ref={formRef} form={BasicInsert} onFinish={() => BasicInsertForm()} layout="vertical" >
                        <div className="row">

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Divsion" name={"DivsionName"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Divsion !',
                                        }
                                    ]}>
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Plant" name={"Plant"} rules={[
                                        {
                                            required: true,
                                            message: 'Select Plant !',
                                        }
                                    ]}>
                                        <Select onChange={PlantMasterChange}>
                                            {PlantMasterData.length > 0 && PlantMasterData.map((Item, index) => (
                                                <Select.Option key={index} value={Item.id}>
                                                    {Item.plantType}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Area" name={"Area"} rules={[
                                        {
                                            required: true,
                                            message: 'Select Area !',
                                        }
                                    ]}>
                                        <Select onChange={AreaMasterChange}>
                                            {AreaMasterData.length > 0 && AreaMasterData.map((Item, index) => (
                                                <Select.Option key={index} value={Item.areaType}>
                                                    {Item.areaType}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>

                            {area === 'Others' && (
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <Form.Item
                                            label="Mention Area"
                                            name="MentionArea"
                                            rules={[
                                                {
                                                    required: area === "Others",
                                                    message: 'Enter Name!',
                                                },]}
                                        >
                                            <Input
                                                style={{ width: '100%' }}
                                                disabled={area !== "Others"}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            )}

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Department" name={"Department"} rules={[
                                        {
                                            required: true,
                                            message: 'Select Department !',
                                        }
                                    ]}>
                                        <Select>
                                            {DepartmentBasedDevision.length > 0 && DepartmentBasedDevision.map((Item, index) => (
                                                <Select.Option key={index} value={Item.id}>
                                                    {Item.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Name" name={"Name"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Name !',
                                        }
                                    ]}>
                                        <Input style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Permit Date" name={"IssueDate"} rules={[
                                        {
                                            required: true,
                                            message: 'Select Issue Date !',
                                        }
                                    ]}>
                                        <DatePicker format={"DD/MM/YYYY"} placement="bottomLeft" style={{ width: '100%' }} minDate={dayjs(new Date())} maxDate={dayjs(new Date())} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Permit Start Time" name={"IssueStartTime"} rules={[
                                        {
                                            required: true,
                                            message: 'Select Start Time !',
                                        }
                                    ]}>
                                        <TimePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Permit End Time" name={"IssueEndTime"} rules={[
                                        {
                                            required: true,
                                            message: 'Select End Time !',
                                        }
                                    ]}>
                                        <TimePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Contractor Name" name={"ContractorName"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Contractor Name !',
                                        }
                                    ]}>
                                        <Input style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Number Of Persons" name={"NumberOfPersons"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Number Of Persons !',
                                        }
                                    ]}>
                                        <Input type='number' onKeyDown={handleKeypress} min='1' step='1' style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Name Of Persons" name={"NameOfPersons"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Persons !',
                                        }
                                    ]}>
                                        <TextArea rows={3} style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Description Of Work" name={"DescriptionOfWork"} rules={[
                                        {
                                            required: true,
                                            message: 'Enter Description !',
                                        }
                                    ]}>
                                        <TextArea rows={3} style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-12">
                                <Form.Item className="FormButtonClass" >
                                    <Button type="primary" danger onClick={clearToPermit}>Cancel</Button>
                                    <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>Submit</Button>
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </>
            }

            {!ShowBasiDetail &&
                <>
                    <div className="permitAccess_web">
                        <div className="Table_Header_Search_Class">

                            <div style={{ flexGrow: '4' }}></div>
                            <h1 style={{ flexGrow: '4' }}>Permit List</h1>
                            <Input style={{ flexGrow: '4' }}
                                allowClear
                                onChange={(e) => onSreach(e.target.value)}
                                className="SearchBox_Class" prefix={<SearchOutlined />} />&nbsp;
                            {LoginInfo?.isCreator === true ?
                                <Tooltip placement="bottomLeft" title='Create Permit' >
                                    <PlusSquareFilled className="AddIcon" onClick={createPermit} />
                                </Tooltip> : ""}
                        </div>
                    </div>

                    <div>
                        <div className="PermitAccess_Mob">
                            <div style={{ flexGrow: '4' }}></div>
                            <h1 className="MobHeader" style={{ flexGrow: '4', }}>Permit List</h1>
                            <div style={{ flexGrow: '4' }}></div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Input
                                    onChange={(e) => onSreach(e.target.value)}
                                    className="SearchBox_Class_Mob" prefix={<SearchOutlined />} />
                                {LoginInfo?.isCreator === true ?
                                    <Tooltip title='Create Permit'>
                                        <PlusSquareFilled className="AddIcon_Mob" onClick={createPermit} />
                                    </Tooltip> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                        {TableShowData?.data?.length > 0 ?
                            <>
                                <Table_Comp GridData={TableShowData} RowClick={RowClick} RowClickMob={RowClickMob} SearchData={SearchData} />
                                <Pagination
                                    current={current}
                                    total={TableShowData?.count}
                                    showTotal={(total) => `Total ${total}`}
                                    onChange={onChangeLogic}
                                    showSizeChanger={true} />
                            </>
                            :
                            <div className="NoDataFoundTextClass">
                                <h4 style={{ color: "black" }}>No Data Found</h4>
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}
export default PermitBasicPage;